import TapeIcon from "@/components/icons/TapeIcon";
import ToolsIcon from "@/components/icons/ToolsIcon";
import ShieldIcon from "@/components/icons/ShieldIcon";
import CreditCardIcon from "@/components/icons/CreditCardIcon";
import ApplianceIcon from "@/components/icons/ApplianceIcon";
import StairsIcon from "@/components/icons/StairsIcon";
import TimeIcon from "@/components/icons/TimeIcon";
import FuelIcon from "@/components/icons/FuelIcon";
import IconFeature from "@/components/IconFeature";

export default function IconGrid() {

    function LargeFeatureIcon({icon, title}) {
        return (
            <div className={"bg-white border border-inactive-grey rounded-lg p-[40px] pb-[32px]"}>
                <IconFeature size={"lg"} icon={icon} title={title}/>
            </div>
        )
    }

    return (
        <>
            <div className="smart-tag mb-[24px] mx-auto">
                🧠 Smart Move System™
            </div>
            <div className="heading-h2 text-center mb-[24px]">
                Why should you choose this Smart Move™?
            </div>
            <div className={"grid grid-cols-2 lg:grid-cols-4 gap-[16px] lg:gap-[32px]"}>
                <LargeFeatureIcon icon={<TapeIcon/>} title={"Home and furniture protection included"} />
                <LargeFeatureIcon icon={<ToolsIcon/>} title={"Free furniture assembly"} />
                <LargeFeatureIcon icon={<ShieldIcon/>} title={"$2,000 damage coverage included"} />
                <LargeFeatureIcon icon={<CreditCardIcon/>} title={"No credit card processing fees"} />
                <LargeFeatureIcon icon={<ApplianceIcon/>} title={"Appliance disconnection/reconnection (expect gas)"} />
                <LargeFeatureIcon icon={<StairsIcon/>} title={"No stairs fee"} />
                <LargeFeatureIcon icon={<TimeIcon/>} title={"On-time guarantee"} />
                <LargeFeatureIcon icon={<FuelIcon/>} title={"No trip fees"} />
            </div>
        </>
    )
}
